'use client'

import { lazy, Suspense } from 'react'
import { LandingHeader } from '@/components/landing/LandingHeader'
import { HeroSection } from '@/components/landing/HeroSection'
import { LandingFooter } from '@/components/landing/LandingFooter'
import { AnimatedBackground } from '@/components/landing/AnimatedBackground'

// Lazy load below-the-fold components for better initial load performance
const FeaturesSection = lazy(() => import('@/components/landing/FeaturesSection').then(m => ({ default: m.FeaturesSection })))
const PartnersSection = lazy(() => import('@/components/landing/PartnersSection').then(m => ({ default: m.PartnersSection })))
const OwnerJourneySection = lazy(() => import('@/components/landing/OwnerJourneySection').then(m => ({ default: m.OwnerJourneySection })))
const ClientJourneySection = lazy(() => import('@/components/landing/ClientJourneySection').then(m => ({ default: m.ClientJourneySection })))
const PricingSection = lazy(() => import('@/components/landing/PricingSection').then(m => ({ default: m.PricingSection })))
const TestimonialsSection = lazy(() => import('@/components/landing/TestimonialsSection').then(m => ({ default: m.TestimonialsSection })))
const FAQSection = lazy(() => import('@/components/landing/FAQSection').then(m => ({ default: m.FAQSection })))
const CTASection = lazy(() => import('@/components/landing/CTASection').then(m => ({ default: m.CTASection })))

// Simple loading placeholder
function SectionLoader() {
  return <div className="h-64 w-full" /> // Minimal height to prevent layout shift
}

export default function LandingPage() {
  return (
    <div className="min-h-screen flex flex-col relative">
      <AnimatedBackground />
      <LandingHeader />
      <main className="flex-1 relative z-0">
        <HeroSection />
        <Suspense fallback={<SectionLoader />}>
          <FeaturesSection />
        </Suspense>
        <Suspense fallback={<SectionLoader />}>
          <PartnersSection />
        </Suspense>
        <Suspense fallback={<SectionLoader />}>
          <OwnerJourneySection />
        </Suspense>
        <Suspense fallback={<SectionLoader />}>
          <ClientJourneySection />
        </Suspense>
        <Suspense fallback={<SectionLoader />}>
          <PricingSection />
        </Suspense>
        <Suspense fallback={<SectionLoader />}>
          <TestimonialsSection />
        </Suspense>
        <Suspense fallback={<SectionLoader />}>
          <FAQSection />
        </Suspense>
        <Suspense fallback={<SectionLoader />}>
          <CTASection />
        </Suspense>
      </main>
      <LandingFooter />
    </div>
  )
}
